<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('assessments-list')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('Assessments')}}
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('Management')}}
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('assessments-list')}}
            </li>
        </ol>
    </div>
    @if (isLoadingResults || isRateLimitReached) {
    <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner></mat-spinner>
        }
        @if (isRateLimitReached) {
        <div class="rate-limit-reached">
            ALTAIR rate limit has been reached. It will be reset in one minute.
        </div>
        }
    </div>
    }
    <!-- Assessments -->
    <mat-card class="altair-card companies-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-header>
            <mat-card-title>
                <form class="search-box position-relative">
                    <i class="material-symbols-outlined">
                        search
                    </i>
                    <input matInput class="input-search d-block w-100 border-none outline-0"
                        placeholder="{{t('search')}} {{t('assessment')}}..." (keyup)="applyFilter($event)"
                        (keydown.enter)="onKeydown($event)" #input>
                </form>
            </mat-card-title>
            @if (roleName == internal) {
            <mat-card-subtitle>
                <a mat-button class="add-new-btn" routerLink="/vulnerability/create-assessment">
                    + {{t('add-new-assessment')}}
                </a>
            </mat-card-subtitle>
            }
        </mat-card-header>
        <mat-card-content>
            <div class="companies-table">
                <div class="table-responsive" #TABLE>
                    <table mat-table [dataSource]="dataSource" matSort matSortActive="assessmentName"
                        matSortDisableClear matSortDirection="asc">

                        <!-- Assessment Name Column -->
                        <ng-container matColumnDef="assessmentName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('name')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                @if (row.assessmentName.length > 60) {
                                {{row.assessmentName.slice(0,60)}}<br>
                                {{row.assessmentName.slice(60,120)}}
                                } @else {
                                {{row.assessmentName}}
                                }
                            </td>
                        </ng-container>

                        <!-- Description Column -->
                        <ng-container matColumnDef="description">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('description')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                @if (row.description.length > 60) {
                                {{row.description.slice(0,60)}}<br>
                                {{row.description.slice(60,120)}}
                                } @else {
                                {{row.description}}
                                }
                            </td>
                        </ng-container>

                        <!-- Company Name Column -->
                        <ng-container matColumnDef="companyName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('company')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.branchOffice.company.name}}
                            </td>
                        </ng-container>

                        <!-- Branch Office Name Column -->
                        <ng-container matColumnDef="branchOfficeName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('branch-office')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.branchOffice.name}}
                            </td>
                        </ng-container>

                        <!-- Start Date Column -->
                        <ng-container matColumnDef="startDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('start-date')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.startDate.substring(0, 10)}}
                            </td>
                        </ng-container>

                        <!-- Company Name Column -->
                        <ng-container matColumnDef="vulnerabilitiesCount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('count')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.vulnerabilitiesCount}}
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('action')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div class="action-info">
                                    <a mat-button routerLink="/vulnerability/view-vulnerabilities/{{row.id}}"
                                        matTooltip="{{t('view')}} {{t('vulnerabilities')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            visibility
                                        </i>
                                    </a>
                                    @if (roleName == internal) {
                                    <a mat-button routerLink="/vulnerability/edit-assessment/{{row.id}}"
                                        matTooltip="{{t('edit')}} {{t('assessment')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            edit
                                        </i>
                                    </a>
                                    <button type="button" mat-button (click)="delete(row.id)"
                                        matTooltip="{{t('delete')}} {{t('assessment')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            delete
                                        </i>
                                    </button>
                                    }
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{t('no-data-matching')}} "{{input.value}}"</td>
                        </tr>

                    </table>
                </div>
                <mat-paginator [length]="totalItems" [pageSizeOptions]="pageSizes" showFirstLastButtons></mat-paginator>
                <button mat-raised-button color="altair" (click)="exportTOExcel()">{{t('export-as-excel')}}</button>
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>
